var canvas: HTMLCanvasElement;
var context: CanvasRenderingContext2D;

// mail an b.kuhstoss@web.de
// game variables
var score = 0;
var num_fruit_on_board = 0;
var fruit_coord = {
    x:200,
    y:200
}

var special_fruit_there = false;
var special_fruit_coord = {
    x: 0, y:  0
}
var special_fruit_countdown = 0;

type Point = {x: number, y: number }
var middle = {
    x: 400,
    y: 400
}
var r = 100;
var r_pos = r;
var v_r = 100; // pixels per second
var hue = 0;

var player_radius = 30
var segment_length = 15;
var dir = {
    x: 0,
    y: 0
}
var tail: Point[] = [];
var last_eaten = 100;


//
var death = false;
var highscore = 0
var last_scores : number[] = [];

// system variables
var last_tick_t = 0;
var width: number;
var height: number;
var keyStates: Set<string> = new Set();


//var logo = new Image();
//logo.src = "logo.png";

/* class Fruit {
    constructor(x,y,i) {
        
    }
} */

function draw() {
    context.resetTransform();
    context.clearRect(0, 0, width, height);

    // draw polygon/path
/*     context.translate(middle.x, middle.y);
    context.rotate(hue / 360 * 2 * Math.PI);
    context.beginPath();
    context.moveTo(0, -r);
    context.lineTo(r_pos, -r_pos);
    context.lineTo(r, 0);
    context.lineTo(r_pos, r_pos);
    context.lineTo(0, r);
    context.lineTo(-r_pos, r_pos);
    context.lineTo(-r, 0);
    context.lineTo(-r_pos, -r_pos);
    context.fill(); */



    // before translate
    
    // draw fruit
    if (num_fruit_on_board > 0){
        context.font = "50pt sans-serif"; 
        context.textAlign = 'center';
        context.fillText(`🍎`, fruit_coord.x, fruit_coord.y)
    }

    // draw fruit
    if (special_fruit_there == true){
        context.font = "50pt sans-serif"; 
        context.textAlign = 'center';
        context.fillText(`🍌`, special_fruit_coord.x, special_fruit_coord.y)
    }


    // draw tail
    let hue_ = hue
    for(let element of tail){
        context.fillStyle = `hsl(${hue_}, 50%, 50%)`
        hue_ = (hue_ + 1) % 360;
        context.beginPath();
        context.arc(element.x,element.y,player_radius,0,2*Math.PI);
        context.fill();
    }

    // draw circle
    context.fillStyle = `hsl(${hue}, 50%, 50%)`
    context.translate(middle.x, middle.y);
    context.beginPath();
    context.arc(0,0,player_radius,0,2*Math.PI)
    context.fill();

    // context.drawImage(logo, 100, 100);
    context.fillStyle = `black`
    context.font = "10pt sans-serif"; 
    context.textAlign = 'center';
    if(last_eaten < 30){
        context.fillText("^____^", 0, 10)
    }
    else{
        context.fillText("0____0", 0, 10)
    }



    context.resetTransform();
    // draw score
    context.fillStyle = `purple`
    context.font = "18pt sans-serif"; 
    context.textAlign = 'left';
    context.fillText(`Score: ${score}`, width * 0.85, height * 0.1)
    context.fillText(`Highscore: ${highscore}`,  width * 0.85, height * 0.16)
    context.fillText(`Last scores:`, width * 0.85, height * 0.27)
    let i = 1
    for (let sc of last_scores){
        context.fillText(`${sc}`, width * 0.85, height * (0.27+ i * 0.05))
        i += 1
        if (i > 10){
            break;
        }
    }

}   

function update_direction(){

/*     if (keyStates.size > 0){
        dir.x = 0;
        dir.y = 0;

        if (keyStates.has("w")){
            dir.y +=  -1;
        }
        if (keyStates.has("a")){
            dir.x += -1;
        }
        if (keyStates.has("s")){
            dir.y += 1;
        }
        if (keyStates.has("d")){
            dir.x += 1;
        }
    } */

    if (keyStates.has("w")){
        dir.x =  0;
        dir.y =  -1;
    }

    if (keyStates.has("a")){
        dir.x = -1;
        dir.y = 0;
    }

    if (keyStates.has("s")){
        dir.x = 0;
        dir.y = 1;
    }
            
    if (keyStates.has("d")){
        dir.x = 1;
        dir.y = 0;
    }

}

function update_position(dt:number): void{
    // position
    let speedup = (100 + score * 2 ) / 100
    middle.x += 200 * dir.x * dt * speedup;
    middle.y += 200 * dir.y * dt * speedup;

    if (middle.x > width) {
        middle.x = 0;
    }

    if (middle.x < 0) {
        middle.x = width;
    }
    if (middle.y > height) {
        middle.y = 0;
    }
    if (middle.y < 0) {
        middle.y = height;
    }
    
    let sth = {x : middle.x, y: middle.y};
    tail.unshift(sth);
    //}
    while (tail.length > score * segment_length){
        tail.pop()
    }
}
function update_fruit(){
    if (num_fruit_on_board == 0){
        // create fruit
        fruit_coord.x = (Math.random()*0.9 + 0.1)  * width;
        fruit_coord.y = (Math.random()* 0.9 + 0.1) * height;
        num_fruit_on_board = 1
    }

    // sometimes destroy fruit
    if (Math.random()  < 0.001){
        num_fruit_on_board = 0;
    }

    // can happen if resize
    if (fruit_coord.x > height || fruit_coord.y > width){
        num_fruit_on_board = 0;
    }

    if (special_fruit_countdown < 1){
        special_fruit_there = false
    }

    if (Math.random() < 0.002 && special_fruit_there == false){
        special_fruit_there = true
        special_fruit_coord.x = (Math.random()*0.9 + 0.1)  * width;
        special_fruit_coord.y = (Math.random()*0.9 + 0.1)  * height;
        special_fruit_countdown = 300;
    }

    special_fruit_countdown += -1;
}

function update(dt: number) {

    if (death){
        last_scores.unshift(score);
        if (score > highscore){
            highscore = score;
        }
        score = 0;
        dir.x = 0;
        dir.y = 0;
        middle.x = 400;
        middle.y = 400;
        death = false;
    }

    // SPIELER
    // direction
    update_direction();
    // position
    update_position(dt);
    // color
    hue = (hue + 1) % 360;
    // player_radius = 30 + score * 5

    // FRUIT
    update_fruit()


    if ((middle.x - fruit_coord.x)**2 + (middle.y + 20 - fruit_coord.y)**2 < (player_radius + 3) ** 2){
        score += 1
        num_fruit_on_board = 0
        last_eaten = 0;
    }
    else if (special_fruit_there && (middle.x - special_fruit_coord.x)**2 + (middle.y + 20 - special_fruit_coord.y)**2 < (player_radius +3 ) ** 2){
        score += 5
        special_fruit_there = false;
        last_eaten = 0;
    }
    else{
        last_eaten += 1;
    }

    for(let i = 20; i < tail.length; i += 1){
        let element = tail[i]
        if ((middle.x - element.x)**2 + (middle.y - element.y)**2 < 2* (player_radius) ** 2){
            death = true
        }
    } 

}

function loop(t_ms: number) {
    // calculate dt
    let dt = t_ms - last_tick_t;
    last_tick_t = t_ms;

    update(dt / 1000); // to seconds
    draw();

    window.requestAnimationFrame(loop);
}

function resized() {
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
}

function key(e: KeyboardEvent) {
    switch (e.type) {
        case "keydown":
            keyStates.add(e.key);
            break;
        case "keyup":
            keyStates.delete(e.key);
            break;
        default:
            console.warn("Wut?");
    }
}

/* 
function click(e: MouseEvent) {
    middle.x = e.offsetX;
    middle.y = e.offsetY;
} */

function main() {
    canvas = document.getElementById("canvas") as HTMLCanvasElement;
    context = canvas.getContext("2d")!;
    window.addEventListener("keydown", key);
    window.addEventListener("keyup", key);
    window.addEventListener("resize", resized);
    //canvas.addEventListener("click", click);
    resized();
    loop(performance.now());
}

main();